import { render, staticRenderFns } from "./vocabularyTestList.vue?vue&type=template&id=394b74df&scoped=true"
import script from "./vocabularyTestList.vue?vue&type=script&lang=js"
export * from "./vocabularyTestList.vue?vue&type=script&lang=js"
import style0 from "./vocabularyTestList.vue?vue&type=style&index=0&id=394b74df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b74df",
  null
  
)

export default component.exports